import { render } from "./RegisterIcon.vue?vue&type=template&id=44fb05ae"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/RegisterIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44fb05ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44fb05ae', __exports__)) {
    api.reload('44fb05ae', __exports__)
  }
  
  module.hot.accept("./RegisterIcon.vue?vue&type=template&id=44fb05ae", () => {
    api.rerender('44fb05ae', render)
  })

}


export default __exports__